import React from 'react';
import { Link } from 'react-router-dom';
import { FaBullseye, FaEye, FaHandshake, FaStar, FaUsers, FaGlobe } from 'react-icons/fa';
import './About.css';

const MissionVision = () => {
  const goals = [
    {
      icon: <FaStar />,
      title: 'Excellence in Training',
      description: 'Provide world-class coaching programs that develop skills, technique, and competitive spirit in players of all levels.'
    },
    {
      icon: <FaUsers />,
      title: 'Community Building',
      description: 'Foster an inclusive community where people connect through their shared love of badminton and healthy competition.'
    },
    {
      icon: <FaGlobe />,
      title: 'Sport Development',
      description: 'Contribute to the growth of badminton locally and nationally by nurturing talent and hosting quality events.'
    },
    {
      icon: <FaHandshake />,
      title: 'Accessible Sport',
      description: 'Make badminton accessible to everyone regardless of age, background, or skill level through diverse programs and pricing.'
    }
  ];

  return (
    <div className="mission-vision-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Our Purpose</span>
            <h1>Mission & Vision</h1>
            <p>Driving excellence and community in badminton</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/about">About</Link>
              <span>/</span>
              <span>Mission & Vision</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section section">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-content">
              <div className="mission-icon">
                <FaBullseye />
              </div>
              <span className="section-badge">Our Mission</span>
              <h2>Empowering Players, Building Champions</h2>
              <p>
                Our mission is to deliver high-quality, structured, and holistic badminton coaching that focuses on complete player development. We are committed to building strong fundamentals, refining advanced techniques, and enhancing physical fitness, agility, and endurance through systematic training programs. At Net Nest Badminton Sports Club, we place equal importance on mental strength, match temperament, and sportsmanship, ensuring players are prepared both on and off the court. We strive to maintain a safe, positive, and motivating training environment where discipline, teamwork, consistency, and respect for the sport are encouraged, helping each player achieve their full potential and develop a lifelong passion for badminton.
              </p>
              <ul className="mission-list">
                <li>Delivering professional-quality training in a supportive environment</li>
                <li>Maintaining world-class facilities that enable peak performance</li>
                <li>Building a vibrant community united by passion for the sport</li>
                <li>Promoting health, fitness, and sportsmanship through badminton</li>
                <li>Making badminton accessible and enjoyable for everyone</li>
              </ul>
            </div>
            <div className="mission-image">
              <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Mission" />
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section section">
        <div className="container">
          <div className="vision-grid">
            <div className="vision-image">
              <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Vision" />
            </div>
            <div className="vision-content">
              <div className="vision-icon">
                <FaEye />
              </div>
              <span className="section-badge">Our Vision</span>
              <h2>The Future of Badminton Excellence</h2>
              <p>
                Our vision at Net Nest Badminton Sports Club is to establish a benchmark of excellence in badminton training and player development. We aspire to create a professional sports environment where players of all ages and skill levels receive world-class guidance and opportunities to grow. Our long-term vision is to identify and nurture young talent, develop technically strong and mentally confident players, and prepare them to compete successfully at district, state, national, and international platforms. Beyond competitive success, we envision promoting badminton as a lifelong sport that builds fitness, discipline, confidence, and strong character, contributing positively to the personal and social development of every player.
              </p>
              <p>
                Our vision extends beyond our facility walls. We aspire to:
              </p>
              <ul className="vision-list">
                <li>Produce nationally competitive players who represent our values</li>
                <li>Be a model for sports facilities worldwide in community building</li>
                <li>Lead innovation in badminton training methodologies</li>
                <li>Expand our reach to serve more communities</li>
                <li>Inspire the next generation of badminton enthusiasts</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Goals Section */}
      <section className="goals-section section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Strategic Goals</span>
            <h2>Our Commitments</h2>
            <p>The pillars that guide our path forward</p>
          </div>
          <div className="goals-grid">
            {goals.map((goal, index) => (
              <div className="goal-card" key={index}>
                <div className="goal-icon">{goal.icon}</div>
                <h3>{goal.title}</h3>
                <p>{goal.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="quote-section">
        <div className="container">
          <blockquote>
            <p>"Badminton is not just a sport; it's a pathway to discipline, friendship, and personal growth. At Net Nest, we're building more than players—we're building character."</p>
            <cite>— Sahil Kumar, Coach</cite>
          </blockquote>
        </div>
      </section>
    </div>
  );
};

export default MissionVision;
